const pontoSigTableNames = {
  tipoPorNumero: {
    1: 'rede',
    2: 'hidrometro',
    3: 'reservatorio',
    4: 'motoBomba',
    5: 'valvula',
    6: 'vazamento',
  },
  columns: {
    hidrometro: {
      nomeDoProprietarioDaUC: 'Nome do proprietário da UC',
      numeroDaCasa: 'Número da casa',
      telefoneDoProprietario: 'Telefone do proprietário',
      numeroDaUC: 'Número da UC',
      valorAtualDaLeituraDaUC: 'Valor da leitura da UC',
      tipoDoConsumidor: 'Tipo do Consumidor',
    },
    motoBomba: {
      potenciaMotor: 'Potência do Motor (cv)',
      marcaDoConjuntoMotoBomba: 'Marca do Conjunto Moto-Bomba',
      modeloDoConjuntoMotoBomba: 'Modelo do Conjunto Moto-Bomba',
      tipoDeBomba: 'Tipo de Bomba',
      dataDaUltimaManutencao: 'Data da Última Manutenção',
    },
    rede: {
      profundidadeTubo: 'Profundidade do Tubo (m)',
      diametroTubo: 'Diâmetro do Tubo (mm)',
      distanciaHorizontalTuboAoMeioFio:
        'Distância Horizontal do Tubo ao Meio Fio (m)',
      materialTubo: 'Material do Tubo',
      localInstalacao: 'Local de Instalação',
    },
    reservatorio: {
      identificacaoDoReservatorio: 'Identificação do Reservatório',
      volumeDoReservatario: 'Volume do Reservatório (m3)',
      materialConstrutivo: 'Material Construtivo',
      tipoDoReservatorio: 'Tipo do Reservatório',
    },
    valvula: {
      diametroDaValvula: 'Diâmetro da Válvula (mm)',
      modeloDaValvula: 'Modelo da Válvula',
    },
    vazamento: {
      tipoDeVazamento: 'Tipo de Vazamento',
      magnitudeDoVazamento: 'Magnitude do Vazamento',
    },
  },
}

export default pontoSigTableNames
